
export * from './device'
export * from './gpu'

export function sleep(ms:number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

